export default "__VITE_ASSET__DyF0PfPK__"